import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { FiUploadCloud } from "react-icons/fi";
import { GoAlert } from "react-icons/go";
import { AiFillCloseCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";

import Error from "../form/Error";

const LogoUploader = ({
  imageUrl,
  isMultiple,
  files,
  setFiles,
  warning,
  onDrop,
  error,
  isLogo,
  validations,
  control,
  field,
  setValue,
  selectedSection,
  max,
}) => {
  // Hooks
  console.log("files in logo uploader", files);
  const { t } = useTranslation();
  const maxFiles = max || 1;
  const [resolutionError, setResolutionError] = useState("");

  const validateLogoResolution = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width >= 200 && img.height >= 60) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
    });
  };

  const handleFileUpload = async (acceptedFiles) => {
    const validFiles = [];
    setResolutionError("");
    for (const file of acceptedFiles) {
      const isValid = await validateLogoResolution(file);
      if (isValid) {
        validFiles.push(
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        );
      } else {
        setResolutionError("Logo resolution must be at least 200x60.");
      }
    }
    setFiles(validFiles);

    // Save files to local storage
    localStorage.setItem("uploadedFiles", JSON.stringify(validFiles));
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: isMultiple || false,
    onDrop: handleFileUpload,
  });

  // Delete handler (removes by index)
  const handleRemove = (index) => {
    console.log("Removing file at files:", files);
    const arr = [...files];
    arr.splice(index, 1);
    setFiles(arr);
  };
  const isUploaderDisabled = (files?.length || 0) >= maxFiles;

  // Filter out invalid entries before mapping
  const thumbs = files
    ?.filter((file) => file !== null && file !== undefined)
    .map((file, index) => (
      <div key={file?.name} className="mx-5">
        <div className="relative">
          <img
            className="inline-flex border-2 border-gray-100 w-24 max-h-24"
            src={file?.preview}
            alt={file?.name}
            style={isLogo ? { width: "200px", height: "60px" } : {}}
          />
          <span
            className="text-red-400 absolute text-2xl cursor-pointer"
            style={{ top: "-12px", right: "-10px" }}
            onClick={() => handleRemove(index)}
          >
            <AiFillCloseCircle />
          </span>
        </div>
      </div>
    ));

  const displayServerImage = (imgUrl, index) => {
    if (!imgUrl) {
      console.warn("Empty or invalid server image URL at index:", index);
      return null;
    }
    console.log("Rendering server image:", imgUrl);
    return (
      <div className="relative mx-2">
        <img
          className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2"
          src={imgUrl}
          alt="product"
          style={isLogo ? { width: "200px", height: "60px" } : {}}
        />
        <span
          className="text-red-400 absolute text-2xl cursor-pointer"
          style={{ top: "-12px", right: "-10px" }}
          onClick={() => {
            setValue("store.storeLogoUrl", null);
          }}
        >
          <AiFillCloseCircle />
        </span>
      </div>
    );
  };

  useEffect(() => {
    // Restore files from local storage on page reload
    const savedFiles = JSON.parse(localStorage.getItem("uploadedFiles"));
    if (savedFiles) {
      setFiles(savedFiles);
    }
  }, [setFiles]);

  const removeImageUrl = (index) => {
     console.log("removeImageUrl called with index:", index);
  
    //   const updatedImageUrls = [...imageUrls];
    //   updatedImageUrls.splice(index, 1);
    //   setFiles(updatedImageUrls);
  
      //console.log("Updated imageUrls after removal:", updatedImageUrls);
    };

  useEffect(() => {
    console.log("Current files:", files);
  }, [files]);

  return (
    <div className="w-full text-center">
      <Controller
        control={control}
        name={field}
        rules={validations}
        render={() => (
          <div
            className={`px-6 pt-5 pb-6 border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer ${
              isUploaderDisabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
            {...(isUploaderDisabled ? {} : getRootProps())}
          >
            <input {...getInputProps()} disabled={isUploaderDisabled} />
            <span className="mx-auto flex justify-center">
              <FiUploadCloud className="text-3xl text-towne-blue" />
            </span>
            <p className="text-sm mt-2 dark:text-gray-400">
              {isUploaderDisabled
                ? `You can only upload up to ${maxFiles} images.`
                : `Drag your ${isMultiple ? "images" : "image"} here`}
            </p>
            <em className="text-xs text-gray-400">
              ({t("accepted-file-types-text")})
            </em>
          </div>
        )}
      />
      {warning && !error && (
        <span className="text-sm mt-2 flex items-center text-gray-500">
          <GoAlert /> <span className="ml-2">{warning}</span>
        </span>
      )}
      {error && (
        <span className="text-left flex items-center text-red-400">
          <Error errorName={error} />
        </span>
      )}
      {resolutionError && (
        <span className="text-left flex items-center text-red-400 text-sm mt-2">{resolutionError}</span>
      )}

      {/* Unified image previews */}
      <aside className="flex flex-row flex-wrap mt-4">
        {!files[0] && displayServerImage(imageUrl, 0)}
        {/* {imageUrl && !files[0] && (
          <div>
            <img
              className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2"
              src={imageUrl}
              alt="product"
            />
            <span
              className="text-red-400 absolute text-2xl cursor-pointer"
              style={{ top: "-12px", right: "-10px" }}
              onClick={() => removeImageUrl(0)}
            >
              <AiFillCloseCircle />
            </span>
          </div>
        )} */}

        {files[0] && thumbs}
      </aside>
    </div>
  );
};

export default LogoUploader;
